<template>
    <div class="accounting-detail-data accounting-bank-transfer-detail">
        <div class="detail-container">
            <div class="detail-section" style="margin-bottom: 30px;">
                <div class="accounting-detail-items" style="margin-top: 25px;">
                    <div class="item vertical">
                        <div class="value xl b" style="padding-bottom: 20px">存款帳戶互轉</div>
                    </div>
                </div>
                <div class="accounting-detail-items">
                    <div class="item">
                        <div class="label">系統單號</div>
                        <div class="value"><el-button type="text" @click="openBankTransferDetail(documentDetail.sno)">{{documentDetail.systemNo}}</el-button></div>
                    </div>
                    <div class="item">
                        <div class="label">互轉日期</div>
                        <div class="value">{{ documentDetail.transferDate | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                </div>
            </div>
            <div class="detail-section">
                <div class="section-title">轉出</div>
                <div class="accounting-detail-items" style="margin-top: 25px;">
                    <div class="item">
                        <div class="label">轉出帳戶</div>
                        <div class="value b">{{ documentDetail.sourceBankName }}</div>
                    </div>
                    <div class="item">
                        <div class="label">轉出金額</div>
                        <div class="value xl">
                            <Money :v="documentDetail.sourceAmt" :precision="documentDetail.sourceCny === 'TWD' ? null : 4" />
                            <span class="cny">{{ documentDetail.sourceCny }}</span>
                        </div>
                    </div>
                    <div class="item" v-if="documentDetail.sourceCny !== 'TWD'">
                        <div class="label">匯率</div>
                        <div class="value">{{ documentDetail.sourceRate }} （約當台幣：<Money :v="documentDetail.sourceAmt * documentDetail.sourceRate" round /> 元）</div>
                    </div>
                    <div class="item">
                        <div class="label">轉出匯費</div>
                        <div class="value">
                            <div v-if="documentDetail.sourceFee">
                                <Money :v="documentDetail.sourceFee" :precision="documentDetail.sourceCny === 'TWD' ? null : 4" />
                                <span class="cny">{{ documentDetail.sourceCny }}</span>
                            </div>
                            <div v-else>--</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">支出項目</div>
                        <div class="value">{{ getHierarchyItemNames(documentDetail.source_ITEM_SNO) }}</div>
                    </div>
                </div>
            </div>
            <div class="detail-section">
                <div class="section-title">轉入</div>
                <div class="accounting-detail-items" style="margin-top: 25px;">
                    <div class="item">
                        <div class="label">轉入帳戶</div>
                        <div class="value b">{{ documentDetail.targetBankName }}</div>
                    </div>
                    <div class="item">
                        <div class="label">轉入金額</div>
                        <div class="value xl">
                            <Money :v="documentDetail.targetAmt" :precision="documentDetail.targetAmt === 'TWD' ? null : 4" />
                            <span class="cny">{{ documentDetail.targetCny }}</span>
                        </div>
                    </div>
                    <div class="item" v-if="documentDetail.targetCny !== 'TWD'">
                        <div class="label">匯率</div>
                        <div class="value">{{ documentDetail.targetRate }} （約當台幣：<Money :v="documentDetail.targetAmt * documentDetail.targetRate" round /> 元）</div>
                    </div>
                    <div class="item">
                        <div class="label">轉入匯費</div>
                        <div class="value">
                            <div v-if="documentDetail.targetFee">
                                <Money :v="documentDetail.targetFee" :precision="documentDetail.targetCny === 'TWD' ? null : 4" />
                                <span class="cny">{{ documentDetail.targetCny }}</span>
                            </div>
                            <div v-else>--</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">收入項目</div>
                        <div class="value">{{ getHierarchyItemNames(documentDetail.target_ITEM_SNO) }}</div>
                    </div>
                </div>
            </div>
        </div>
        <BankTransferDetailDialog :visible="bankTransferDetailDialog.visible" :sno="bankTransferDetailDialog.sno" @close="handleBankTransferDetailDialogClose" />
    </div>
</template>

<script>
export default {
    props: {
        queryType: {
            type: Number,
            default: null,
        },
        datas: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        BankTransferDetailDialog: () => import('@/components/dashboard/Finance/VariableStatement/BankTransferDetailDialog.vue'),
    },
    data() {
        return {
            bankTransferDetailDialog: {
                visible: false,
                sno: null,
            },
            bankAccountList: [],
        };
    },
    created() {
    },
    computed: {
        documentDetail() {
            return this.datas.detail || {};
        },
    },
    methods: {
        getHierarchyItemNames(itemNo) {
            const hierarchy = [null, null, null];

            const types = [
                { key: 'payoutSettings', name: '營業支出' },
                { key: 'invoiceSettings', name: '營業收入' },
                { key: 'cInSettings', name: '營業其他收入' },
                { key: 'cInElseSettings', name: '財務資產收入' },
                { key: 'cOutSettings', name: '營業其他支出' },
                { key: 'cOutElseSettings', name: '財務資產支出' },
            ];

            // eslint-disable-next-line no-restricted-syntax, guard-for-in
            for (const t in types) {
                const options = this.$store.getters['statement/statementUiOptions'][types[t].key];
                // eslint-disable-next-line no-restricted-syntax, guard-for-in
                for (const i in options) {
                    const lv1Item = options[i];
                    // eslint-disable-next-line no-restricted-syntax, guard-for-in
                    for (const j in lv1Item.childSettings) {
                        const lv2Item = lv1Item.childSettings[j];
                        if (lv2Item.sno === itemNo) {
                            hierarchy[0] = types[t].name;
                            hierarchy[1] = lv1Item.iteM_NAM;
                            hierarchy[2] = lv2Item.iteM_NAM;
                            break;
                        }
                    }
                }
            }

            return hierarchy.join(' / ');
        },
        openBankTransferDetail(sno) {
            this.bankTransferDetailDialog.sno = sno;
            this.bankTransferDetailDialog.visible = true;
        },
        handleBankTransferDetailDialogClose() {
            this.bankTransferDetailDialog.visible = false;
            this.bankTransferDetailDialog.sno = null;
        },
    },
};
</script>

<style lang="scss">
.accounting-invoice-detail .minus-row {
    .type,
    .money {
        color: #f00;
    }
}
</style>
